<template>
  <div class="vx-row ml-0">
    <div class="vx-col p-8 vx-card" style="max-height: 750px;overflow-y: scroll">
      <div class="ml-4 " ><span class="title_card">{{$t('generalSettingMenu.titileBtn4')}}</span></div>
      <hr class="opacity-50 mt-4 " style="margin-bottom: 2rem;">
      <div class="row">
        <p style="font-size: 16px">{{$t('rules.textThanks')}}</p>
        <p><strong>{{$t('rules.textConfirm')}}</strong></p>
        <p>{{$t('rules.textSubConfirm')}}</p>
        <p><strong>{{$t('rules.textPossibility')}}</strong></p>
        <p>{{$t('rules.textSubPossibility')}}</p>
        <p><strong>{{$t('rules.textService')}}</strong></p>
        <p>{{$t('rules.textSubService')}}</p>
        <p><strong>{{$t('rules.textAppPhone')}}</strong></p>
        <p>{{$t('rules.textSubAppPhone')}}</p>
        <p><strong>{{$t('rules.textPay')}}</strong></p>
        <p>{{$t('rules.textSubPay')}}</p>
        <p><strong>{{$t('rules.textWisdom')}}</strong></p>
        <p>{{$t('rules.textSubWisdom')}}</p>
        <p><strong>{{$t('rules.textSignUp')}}</strong></p>
        <p>{{$t('rules.textSubSingUp')}}</p>
        <p><strong>{{$t('rules.textUseService')}}</strong></p>
        <p>{{$t('rules.textSubUseService')}}</p>
        <p><strong>{{$t('rules.textSecurity')}}</strong></p>
        <p>{{$t('rules.textSubSecurity')}}</p>
        <p><strong>{{$t('rules.textCancellation')}}</strong></p>
        <p>{{$t('rules.textSubCancellation')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rules"
}
</script>

<style scoped>
.title_card{
  font-weight: bold;
  font-size: 28px;
  margin-left: -1rem;
}
p {
  padding-bottom: 1.5em;
  color: #B9B9C3;
}
strong{
  color: #626262;
}
</style>
